import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsChevronBarUp, BsChevronDown } from 'react-icons/bs';

const MarketOrderByButton = ({
    orderBy,
    onOrderByChange
}) => {

    const [isOrderByOpen, setIsOrderByOpen] = useState(false);
    const orderByDropdownRef = useRef(null);
    const { t } = useTranslation();

    const handleOrderByChange = (newOrderBy) => {
        onOrderByChange(newOrderBy);
        setIsOrderByOpen(false);
    }

    useEffect(() => {
        const handleClickOut = (e) => {
        if (orderByDropdownRef.current && !orderByDropdownRef.current.contains(e.target)) {
            setIsOrderByOpen(false);
        }
        };

        document.addEventListener('mousedown', handleClickOut);

        return () => {
        document.removeEventListener('mousedown', handleClickOut);
        };
    }, []);

    return (
        <div className="w-full relative">
            <button
            className={`
              flex
              flex-row
              items-center
              justify-center
              h-full
              w-full
              py-2
              px-4
              text-primary
              rounded-full
              bg-white
              border
              border-primary
              border-solid
              h-14
              rounded-full
              btn-effects
            `}
            onClick={() => {setIsOrderByOpen(!isOrderByOpen)}}
            >
            <div className="w-[16px]"></div>
            <div className="flex-1 text-center">{orderBy === 'distance' ? t('market.order_by.distance') : t('market.order_by.interests')}</div>
            <div className="">{isOrderByOpen ? <BsChevronBarUp/> : <BsChevronDown/>}</div>
          </button>
          {isOrderByOpen && (
            <ul 
              className="absolute top-full left-0 w-full bg-white border border-gray-200 rounded mt-1 shadow-lg z-10"
            >
              <li>
                <button
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 btn-effects text-primary font-LatoRegular"
                  onClick={() => handleOrderByChange('distance')}
                >
                  {t('market.order_by.distance')}
                </button>
              </li>
              <li>
                <button 
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 btn-effects text-primary font-LatoRegular"
                  onClick={() => handleOrderByChange('interests')}
                >
                  {t('market.order_by.interests')}
                </button>
              </li>
            </ul>
          )}
        </div>
    )
}

export default MarketOrderByButton;